const pinsWidth = 20;

export default () => ({
    flex: '1',
    display: 'flex',
    height: '100%',
    '> div:first-child': {
        width: `calc(100% - ${pinsWidth}rem)`,
        height: '100%',
    },
    '> div:last-child': {
        width: `${pinsWidth}rem`,
        height: '100%',

        overflow: 'auto',
    },
});
